import React from 'react';
import TableColumn from './TableColumn';

function TableBoxActionsColumn(props) {
  return <TableColumn width="calc(3.25rem + 1px)" align="center" {...props} />;
}

export default TableBoxActionsColumn;
